import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { validationMessages } from './validation-messages';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public validationMessages = validationMessages;
  public email: any = 'ash@gmail.com';
  public message: any;
  public submitted = false;
  public loginUsers = [
    { value: 2, viewValue: 'Admin' },
    { value: 3, viewValue: 'Publisher' },
    { value: 1, viewValue: 'SuperAdmin' }
  ];
  public isLoading: boolean = false;
  public button: string = 'LOGIN';

  get f() { return this.loginForm.controls; }

  constructor(private router: Router, private fb: FormBuilder, private apiService: ApiService, private dataService: DataService,
    private toastService: ToastService) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,10}$')]],
      password: ['', [Validators.required]],
      loginPlatform: ['Portal']
    });
    this.dataService.logoutUser();
  }

  /**
 * Logs in the user.
 * Submits the login form and sends a POST request to the API to authenticate the user.
 * If the login is successful, sets user token, role ID, full name, email address, and user ID in the data service.
 * Redirects the user to the appropriate dashboard based on their role ID.
 * Displays an error message if the login fails.
 */
  userLogin() {
    this.isLoading = true;
    this.button = 'Please wait!';
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.apiService.postAPIV3('/user/login', this.loginForm.value).subscribe(res => {
      if (res['statusCode'] == 200) {
        this.dataService.setUserToken(res['result']['token']);
        this.dataService.setRoleId(res['result']['user']['user_role_id']);
        this.dataService.setValue('full_name', res['result']['user']['full_name']);
        this.dataService.setValue('email_address', res['result']['user']['email_address']);
        this.dataService.setValue('userId', res['result']['user']['id']);
        let roleId = res['result']['user']['user_role_id'];
        if (roleId == 1 || roleId == 2) {
          this.router.navigate(['/admin/dashboard']);
          // this.button = 'LOGIN';
          // this.isLoading = false;
        }
        else if (roleId == 3) {
          this.router.navigate(['/publisher/dashboard']);
          // this.isLoading = false;
          // this.button = 'LOGIN';
        }
      } else {
        this.toastService.showError(res['message'], 'Error');
        this.button = 'LOGIN';
        this.isLoading = false;
      }
    });
  }
}
